import type { CSSProperties } from 'react';

/** Dims a container to half opacity while a background refetch is in flight,
 *  so paged tables/grids stay visible instead of blanking between fetches. */
export function fetchingStyle(isFetching: boolean): CSSProperties {
  return { opacity: isFetching ? 0.5 : 1, transition: 'opacity 0.15s' };
}
